<style scoped>
    .edit-prepend{
        display: inline-block;
        width: 36px;
    }
</style>
<template>
  <div>
    <div class="line text-center">
      <div class="search-input">
        <i-input
          v-model="params.search"
          placeholder="请输入搜索关键字"
          @on-enter="doSearch"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="query_item_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>

    <div class="line">
      <Table
        :columns="item_columns"
        :data="items"
        :loading="loading"
      />
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <Modal
      v-model="edit_config.modal"
      width="400"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_config.loading"
      @on-ok="editOk"
    >
      <div class="line text-bold text-large">
        <span>姓名: {{ edit_item.account }}</span>
        <span>卡号: {{ edit_item.bank_number || '无' }}</span>
      </div>
      <div class="line">
        <i-input
          v-model="edit_item.bank"
          placeholder="..."
        >
          <span
            slot="prepend"
            class="edit-prepend"
          >银行</span>
        </i-input>
      </div>
      <div class="line">
        <i-input
          v-model="edit_item.province"
          placeholder="..."
        >
          <span
            slot="prepend"
            class="edit-prepend"
          >开户省</span>
        </i-input>
        <div class="color-error">
          如为直辖市, 请将直辖市填在开户省, 开户市则无需填写
        </div>
      </div>
      <div class="line">
        <i-input
          v-model="edit_item.city"
          placeholder="..."
        >
          <span
            slot="prepend"
            class="edit-prepend"
          >开户市</span>
        </i-input>
      </div>
      <div class="line">
        <i-input
          v-model="edit_item.bank_branch"
          placeholder="..."
        >
          <span
            slot="prepend"
            class="edit-prepend"
          >支行</span>
        </i-input>
      </div>
    </Modal>
  </div>
</template>
<script route="/fin/customer_account">
  import Util from '../../libs/util';
  import BaseItem from '../mixins/base_item';
  export default {
    /* router_info_start */
    router_info: '/fin/customer_account',
    /* router_info_end */
    mixins: [BaseItem],
    data() {
      return {
        query_item_path: Util.api.query_customer_account,
        update_item_path: Util.api.update_customer_account,
        item_columns: [
          {
            title: '姓名',
            key: 'account'
          },
          {
            title: '工号',
            key: 'uid'
          },
          {
            title: '团队',
            key: 'team_name'
          },
          {
            title: '银行',
            key: 'bank'
          },
          {
            title: '开户省',
            key: 'province'
          },
          {
            title: '开户市',
            key: 'city'
          },
          {
            title: '支行',
            key: 'bank_branch'
          },
          {
            title: '卡号',
            key: 'bank_number'
          },
          {
            title: '操作',
            render: (h, params) => {
              const row = params.row;
              const ret = [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click:() => {
                      this.editItem(row);
                    }
                  }
                }, '编辑')
              ];
              return h('div', ret);
            }
          }
        ]
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
